import { useEffect, useState } from 'react';
import { Autocomplete, Checkbox, Chip, Grid, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Tag } from '../../../models/tag';
import { getTagsByGroup } from '../../../api/tag-api';

interface TagSelectorProps {
  selectedTagIds: string[];
  onChange: (ids: string[]) => void;
}

const TagSelector = ({ selectedTagIds, onChange }: TagSelectorProps) => {
  const [mealTypes, setMealTypes] = useState<Tag[]>([]);
  const [cuisines, setCuisines] = useState<Tag[]>([]);

  useEffect(() => {
    getTagsByGroup().then((groups) => {
      setMealTypes(groups.meal_type);
      setCuisines(groups.cuisine);
    });
  }, []);

  if (mealTypes.length === 0 && cuisines.length === 0) {
    return null;
  }

  const selectedMealTypes = mealTypes.filter((t) => selectedTagIds.includes(t.id));
  const selectedCuisines = cuisines.filter((t) => selectedTagIds.includes(t.id));

  const handleMealTypeChange = (_: unknown, value: Tag[]) => {
    const otherIds = selectedTagIds.filter((id) => !mealTypes.some((t) => t.id === id));
    onChange([...otherIds, ...value.map((t) => t.id)]);
  };

  const handleCuisineChange = (_: unknown, value: Tag[]) => {
    const otherIds = selectedTagIds.filter((id) => !cuisines.some((t) => t.id === id));
    onChange([...otherIds, ...value.map((t) => t.id)]);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          multiple
          options={mealTypes}
          value={selectedMealTypes}
          onChange={handleMealTypeChange}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.id}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={selected}
                sx={{ mr: 1 }}
              />
              {option.name}
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.name} size="small" />
            ))
          }
          renderInput={(params) => <TextField {...params} label="Typ jídla" size="small" />}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          multiple
          options={cuisines}
          value={selectedCuisines}
          onChange={handleCuisineChange}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.id}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={selected}
                sx={{ mr: 1 }}
              />
              {option.name}
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.name} size="small" />
            ))
          }
          renderInput={(params) => <TextField {...params} label="Kuchyně" size="small" />}
        />
      </Grid>
    </Grid>
  );
};

export default TagSelector;
